module.exports = __webpack_public_path__ + "img/dot-vertical-2.d68bd09d.svg";